import { todayCalendarDate } from '../../../../components/calendar/monthGrid';
import { uid } from '../../../../lib/uid';

/*
  Autogenerate for the deliberation form. Synthetic values only — the note is obviously a sample, and
  suffixed so two generated notes are told apart.
*/

const OBSERVATIONS = [
  'Strong written exam; clear answers in the final interview.',
  'Meets every qualification standard; references confirmed.',
  'Good fit for the office; recommend for the next round.',
];

/**
 * The NOTE. The Shortlist switch is the flag that reveals it, and a revealing flag stays where the reader
 * set it (frontend-forms.md, Autogenerate) — so this fills what sits behind it and nothing else.
 */
export function sampleDeliberation(): { note: string } {
  const observation = OBSERVATIONS[Math.floor(Math.random() * OBSERVATIONS.length)];

  return {
    note: `<p>Sample deliberation note ${uid().slice(0, 6)}.</p><ul><li><p>${observation}</p></li></ul>`,
  };
}

const HALLS = ['Function Hall A', 'Conference Room 2', "Director's Office"];

/**
 * The Schedule of Oath Taking — all three, two weeks ahead at 09:00, the place suffixed so two generated
 * schedules are told apart. A calendar date built from local y/m/d, never through an instant.
 */
export function sampleOathTaking(): { date: string; time: string; place: string; notes: string } {
  const day = new Date();
  day.setDate(day.getDate() + 14);
  const date = `${day.getFullYear()}-${String(day.getMonth() + 1).padStart(2, '0')}-${String(day.getDate()).padStart(2, '0')}`;

  return {
    date,
    time: '09:00',
    place: `${HALLS[Math.floor(Math.random() * HALLS.length)]} (sample ${uid().slice(0, 6)})`,
    notes: `<p>Sample oath-taking notes ${uid().slice(0, 6)}.</p><ul><li><p>Bring a valid ID.</p></li></ul>`,
  };
}

/**
 * The planned ASSIGNMENT — the posting's own office when it is still live (resolved against the units the
 * form loaded, never an invented id), else the first live unit; a month ahead; an obviously synthetic remark.
 */
export function sampleAssignment(
  units: readonly { id: string }[],
  preferredUnitId: string,
): { orgUnitId: string | null; effectiveDate: string; remarks: string } {
  const day = new Date();
  day.setDate(day.getDate() + 30);

  return {
    orgUnitId: units.find((u) => u.id === preferredUnitId)?.id ?? units[0]?.id ?? null,
    effectiveDate: `${day.getFullYear()}-${String(day.getMonth() + 1).padStart(2, '0')}-${String(day.getDate()).padStart(2, '0')}`,
    remarks: `Sample assignment ${uid().slice(0, 6)} — report to the unit head.`,
  };
}

/**
 * The ENDORSEMENT — every field the form asks: the first LIVE account offered (resolved against the
 * list the form loaded, never an invented id), today, and an obviously synthetic remark. The
 * attachment is a binary whose type the server verifies by its bytes, so it is left for the reader.
 */
export function sampleEndorsement(users: readonly { userId: string }[]): {
  endorsedByUserId: string | null;
  endorsedDate: string;
  remarks: string;
} {
  return {
    endorsedByUserId: users[0]?.userId ?? null,
    endorsedDate: todayCalendarDate(),
    remarks: `Sample endorsement ${uid().slice(0, 6)} — recommended by the board.`,
  };
}
